import script from "./PresentsCont.vue?vue&type=script&setup=true&lang=js"
export * from "./PresentsCont.vue?vue&type=script&setup=true&lang=js"

import "./PresentsCont.vue?vue&type=style&index=0&id=06adbf58&lang=scss"

const __exports__ = script;

export default __exports__